import { useIntl } from "react-intl";

import SimpleImageTextSide from "@/patterns/wpl/simple-image-text-side/src";

const CaptureAndTrack = () => {
    const intl = useIntl();
    const title = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.captureAndTrack.title",
        defaultMessage: "Capture bugs anywhere"
    });

    const bodyText = intl.formatMessage({
        id: "JiraSoftwarePageTemplate.paidLpJswTracker.tabSection.captureAndTrack.listItem.",
        defaultMessage:
            "Identify a bug, create an issue, and add all relevant details. Include descriptions, severity level, screenshots, version, and more. Issues can represent anything — from a software bug, a project task, to a leave request form — and each unique issue type can have its own custom workflow."
    });
    const imageSrc =
        "https://wac-cdn-2.atlassian.com/dam/jcr:4a504247-c5bf-408c-95d8-9aee7b6c3343/create%20issue%202x.png?cdnVersion=ece";
    const imageAlt = "Capture bugs";

    return (
        <SimpleImageTextSide
            headerText={title}
            bodyText={bodyText}
            imageLink={imageSrc}
            imageAltText={imageAlt}
            alignItems={"top"}
            rowProps="4-8"
            className="simple-image-text-side-tabs"
        />
    );
};

export default CaptureAndTrack;
